import React, { Component, Fragment } from 'react';
import axios from 'axios';

import FormGroup from '../../elements/FormGroup'
import Input from '../../elements/Input'
import Select from '../../elements/Select'

import {states} from '../../utilities'

class InsuranceItem extends Component{
  constructor(props){
    super(props);
    this.state = {
      searchResults: [],
      loading: true,
      error: null,
      insuranceName: '',
      searchByCompanyName: '',
      insuranceID: '',
    }
  }

  componentDidMount(){
    this.loadData()
  }

  componentDidUpdate(prevState){
    if(this.state.loading && !prevState.loading){
      this.loadData()
    }
  }

  loadData(){
    var params = {
      skip:0,
      limit: 10000
    };
    if (this.state.searchByCompanyName){
      params.searchByCompanyName = this.state.searchByCompanyName
    }

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_URL}/insurances`,
      params: params,
    }).then(res => {
      if (res.status === 200) {}
      this.setState({searchResults: res.data, loading: false, error: null});
    }).catch(err => {
      console.log(err)
      this.setState({loading: false, error: err});
    })
  }

  format = (list) => {
    if (list && list.length) {
      return list.map(item => {
        return {
          name: `${item.name}`,
          payload: item.id
        }
      })
    }
  }

  onSearch = (property, value, event) => {
    this.setState({
      insuranceName: value,
      searchByCompanyName: value,
      loading: true
    })    
  }

  selectInsurance = (property, value, event) => {
    let insurance = this.state.searchResults.find(item => item.id === parseInt(value))
    let newName = '';
    this.state.searchResults.forEach(item => {
      if (item.id === parseInt(value)) {
        newName = `${item.name}`
      }
    })
    this.props.onSelectInsurance(insurance.id, insurance.name)
    this.setState({      
      insuranceName: newName,
    })
  }

  handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    let insurance = this.state.searchResults.find(item => item.id === parseInt(value))
    this.props.onSelectInsurance(insurance.id, insurance.name)
    this.setState({
      insuranceID: value,
    })
  }

  render(){
    return (
      <Fragment>
        <FormGroup>
          <Input
            placeholder="Insurance Name"
            property="name"
            value={this.props.otherInsuranceInfo.name}
            onChange={this.props.onChangeOtherInsurance}
          />
        </FormGroup>
        <FormGroup>
          <Input
            placeholder="Policy Number"
            property="policy"
            value={this.props.policy}
            onChange={this.props.onChange}
          />
        </FormGroup>
        <FormGroup>
          <Select
            property="relationToInsured"
            value={this.props.relationToInsured}
            onChange={this.props.onChange}
          >
            <option value="">Relation To Insured</option>
            <option value="Self">Self</option>
            <option value="Spouse">Spouse</option>
            <option value="Child">Child</option>
            <option value="Other">Other</option>            
          </Select>
        </FormGroup>
        { this.props.relationToInsured && this.props.relationToInsured !== "Self" &&
          <Fragment>
            <FormGroup>
              <Input
                placeholder="Guarantor Last Name"
                property="lastName"
                value={this.props.guarantor.lastName}
                onChange={this.props.onChangeGuarantor}
              />
            </FormGroup>
            <FormGroup>
              <Input
                property="firstName"
                placeholder="Guarantor First Name"
                value={this.props.guarantor.firstName}
                onChange={this.props.onChangeGuarantor}
              />
            </FormGroup>
            <FormGroup label="Guarantor Date of Birth">
              <Input
                property="dob"
                placeholder="Guarantor DOB"
                value={this.props.guarantor.dob}
                onChange={this.props.onChangeGuarantor}
              />
            </FormGroup>
            <FormGroup>
              <Input
                property="address"
                placeholder="Guarantor Addrress"
                value={this.props.guarantor.address}
                onChange={this.props.onChangeGuarantor}
              />
            </FormGroup>
            <FormGroup>
              <Input
                property="city"
                placeholder="Guarantor City"
                value={this.props.guarantor.city}
                onChange={this.props.onChangeGuarantor}
              />
            </FormGroup>
            <FormGroup>
              <Select
                property="state"
                placeholder="Guarantor State"
                value={this.props.guarantor.state}
                onChange={this.props.onChangeGuarantor}
              >
                <option value="">Select Guarantor State</option>
                {states.map((state) => <option key={state.abbreviation} value={state.abbreviation}>{state.abbreviation}</option>)}
              </Select>
            </FormGroup>
            <FormGroup>
              <Input
                property="zip"
                placeholder="Guarantor Zip"
                value={this.props.guarantor.zip}
                onChange={this.props.onChangeGuarantor}
              />
            </FormGroup>
            <FormGroup>
              <Input
                property="phone"
                placeholder="Guarantor Phone"
                value={this.props.guarantor.phone}
                onChange={this.props.onChangeGuarantor}
              />
            </FormGroup>
          </Fragment>
        }
      </Fragment>
    )
  }

}

export default InsuranceItem
